import React from 'react';
import { combineReducers } from 'redux';
import manageReducer from '../reducers/manage/manage';
import manageSectionDataReducer from '../reducers/manage/data/manage';

const manageDataReducer = combineReducers({ manage: manageSectionDataReducer });

export { manageReducer, manageDataReducer };



// WEBPACK FOOTER //
// ./src/store/ManageStore.js